import { Capacitor } from '@capacitor/core';

export function isNative() {
  // Prefer window.__CAP_IS_NATIVE__ set in index.jsx to avoid race conditions
  if (typeof window !== 'undefined' && typeof window.__CAP_IS_NATIVE__ !== 'undefined') {
    return window.__CAP_IS_NATIVE__;
  }
  
  // Fallback to Capacitor.isNativePlatform()
  try {
    return Capacitor.isNativePlatform();
  } catch {
    return false;
  }
}
